module.exports = __webpack_public_path__ + "img/4.0d4332a.png";